import React, { Component } from "react";
import { Modal, Button, Typography, Icon, Tooltip } from "@plum-xoxo/admin-dsm";
import { XoxodayLongLogo } from "../Icons";
import { StyledBorderHorizontal } from "../../modules/Accounts/PlatformPreferences/Component/styled";

class MessageModal extends Component {
  state = {
    showModal: true,
  };

  handleModal = () => {
    this.setState({
      showModal: false,
    });
    this.props.callbackMethod ? this.props.callbackMethod() : null;
  };

  copyText = () => {
    NotificationManager.success("Text Copied To Clipboard");
  };

  exportCxmlInfo = () => {
    const blob = new Blob([this.props.cxmlData], {
      type: "application/xml",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "recipients.xml";
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener";
    window.open(url, "_blank");
    // link.click();
  };

  render() {
    const { showModal } = this.state;
    const {
      image,
      headerColor,
      header,
      bodyText,
      bodyTextCopy,
      bodyColor,
      body,
      footerAction,
      footerText,
      subHeader,
      subHeaderClass,
      btnText = "Ok",
      headerClassName = "",
      btnClass = "medium",
      footerRight = false,
      footerClassName = "",
      buttonText = "",
      imageClass = "",
      imageWidth = "50%",
      hideCloseIcon = false,
      fundModal,
      cxmlData,
      disableCloseButton = true,
    } = this.props;
    const imgSrc =
      image === "success"
        ? "/admin/img/svg-icons/successAnimation.gif"
        : image == "error"
        ? "/admin/img/icon_failure.png"
        : image != ""
        ? image
        : null;
    return (
      <div>
        {cxmlData ? (
          <Modal
            isOpen={showModal}
            onClose={() => {
              this.handleModal();
            }}
            size="sm"
            style={{ width: "778px", height: "443px" }}
            className="p-36"
          >
            <div className="d-flex justify-content-between">
              <Typography.H2>
                <XoxodayLongLogo width="auto" height="35" />
              </Typography.H2>
              <Typography.H2>
                <img src="/admin/img/workday.png" height="35" />
              </Typography.H2>
            </div>
            <StyledBorderHorizontal className="mt-20" />
            <div className="d-flex justify-content-center mt-28">
              <Icon
                color="success"
                iconName="PlumCheckbox"
                onClick={() => {}}
                padding="2px"
                shade="c03"
                size="l"
              />
            </div>
            <Typography.H2
              color="dark"
              shade="c300"
              className="mb-0 mt-20  text-center"
            >
              Claim Code is sent to your e-procurement system
            </Typography.H2>
            <Typography
              component="div"
              color="dark"
              shade="c200"
              className="mb-0 mt-20  text-center"
            >
              Your claim codes are sent to your e-procurement system. Your claim
              codes will be delivered to recipients after we receive an approval
              from your e-procurement system.
            </Typography>
            <div className="d-flex mt-20 flex justify-content-center text-center">
              <Tooltip offset={[0, 5]} tooltip="Not connected to Oracle">
                <Button
                  variant="outlined"
                  disabled
                  color="primary"
                  onClick={() => {}}
                >
                  Send to Oracle e Procurement
                </Button>
              </Tooltip>
              <Tooltip offset={[0, 5]} tooltip="Not connected to Workday">
                <Button
                  variant="outlined"
                  disabled
                  color="primary"
                  className="ml-20"
                  onClick={() => {}}
                >
                  Send to Workday
                </Button>
              </Tooltip>
              <Button
                variant="outlined"
                color="primary"
                className="ml-20"
                onClick={() => {
                  this.exportCxmlInfo();
                }}
              >
                View cXML
              </Button>
            </div>
            <div className="mt-20 text-center">
              <Typography.BodySmall color="dark" shade="c200">
                Need help? Please contact{" "}
                <Typography
                  component="a"
                  href="https://www.xoxoday.com/company/contact-us"
                  color="primary"
                  shade="c03"
                >
                  cs@giift.com
                </Typography>{" "}
              </Typography.BodySmall>
            </div>
          </Modal>
        ) : (
          <Modal
            isOpen={showModal}
            onClose={() => {
              this.handleModal();
            }}
            disableCloseButton={disableCloseButton}
          >
            <Typography.H2
              component="div"
              className="d-flex justify-content-between align-items-center"
            >
              <Typography.H2 color="dark" shade="c300">
                {header ? header : ""}
              </Typography.H2>
            </Typography.H2>
            {subHeader ? (
              <Typography
                component="div"
                color="dark"
                shade="c200"
                className="mt-12"
              >
                {subHeader}
              </Typography>
            ) : null}
            {bodyText ? (
              <p className={bodyColor ? bodyColor : "default"}>
                {bodyText ? bodyText : ""}
              </p>
            ) : null}
            {fundModal ? (
              <Typography color="dark" shade="c200">
                {fundModal ? fundModal : ""}
              </Typography>
            ) : null}
            <Typography
              component="div"
              className="d-flex justify-content-end w-100 mt-32"
            >
              <Button
                variant="plain"
                onClick={() => {
                  footerAction();
                }}
                className="mr-1"
              >
                {footerText}
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  this.handleModal();
                }}
              >
                {buttonText ? buttonText : "OK, Got it"}
              </Button>
            </Typography>
          </Modal>
        )}
      </div>
    );
  }
}

export default MessageModal;
